import { render, staticRenderFns } from "./Disclaimer.vue?vue&type=template&id=3fd543ee&scoped=true&"
import script from "./Disclaimer.vue?vue&type=script&lang=js&"
export * from "./Disclaimer.vue?vue&type=script&lang=js&"
import style0 from "./Disclaimer.vue?vue&type=style&index=0&id=3fd543ee&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd543ee",
  null
  
)

export default component.exports